import { onInstallService } from './handlers/install'

export const CHAT_PRO_WIDGET = {
  id: 'CHAT_PRO_INTEGRATION',
  type: 'TOKEN',
  name: 'Integração com ChatPro',
  description: 'Criar integração com o ChatPro',
  color: 'light3',
  image: '/services/chat_pro.png',
  categories: ['Comunicação'],
  service: 'chat_pro',
  onClick: onInstallService,
  initialState: {
    name: 'Comunicação',
    data: {
      type: 'O_OUTH'
    }
  }
}
